import { WithStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Zoom from '@material-ui/core/Zoom';
import * as React from 'react';

import { IPortalGroupTraining } from '../actions/portal';
import i18n from '../resources/i18n';

const styles = (theme: Theme) =>
	createStyles({
		card: {
			height: '100%',
			width: 200,
		},
		content: {
			padding: theme.spacing(1),
		},
		groupTrainingTitle: {
			color: theme.palette.primary.main,
			fontSize: '108%',
			marginBottom: theme.spacing(1),
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		media: {
			height: 0,
			paddingTop: '56.25%',
		},
	});

interface IPortalNoticeCardProps {
	groupTraining: IPortalGroupTraining;
	handleShowDetailDialog: (e: React.MouseEvent<HTMLElement>) => void;
}
interface IProps
	extends React.Props<{}>,
		WithStyles<typeof styles>,
		IPortalNoticeCardProps {}

/**
 * お知らせ集合研修カード形式
 * @param props
 */
const PortalNoticeCard: React.FC<IProps> = props => {
	const { classes, groupTraining, handleShowDetailDialog } = props;
	let fromToDate = groupTraining.fromToDate;
	if (fromToDate && fromToDate.indexOf('～') !== -1) {
		fromToDate = fromToDate.replace(
			'～',
			i18n.t('～', {
				ns: 'force',
			})
		);
	}
	return (
		<Zoom in={true}>
			<Card className={classes.card}>
				<CardContent className={classes.content}>
					<Tooltip title={groupTraining.title} placement="top-start">
						<Typography
							variant="h5"
							component="h2"
							className={classes.groupTrainingTitle}
							data-careerid={groupTraining.careerID}
							onClick={handleShowDetailDialog}
						>
							{groupTraining.title}
						</Typography>
					</Tooltip>
					<Typography component="p">
						{i18n.t('PortalNoticeGTCard_0001')}:{' '}
						{groupTraining.className}
					</Typography>
					<Typography component="p">
						{i18n.t('PortalNoticeGTCard_0002')}: {fromToDate}
					</Typography>
				</CardContent>
			</Card>
		</Zoom>
	);
};

export default withStyles(styles)(PortalNoticeCard) as React.ComponentClass<
	IPortalNoticeCardProps
>;



// WEBPACK FOOTER //
// ./src/components/PortalNoticeGTCard.tsx